import { memo } from 'react';

import { FileExtensionPreview } from '@air/component-file-extension-preview';

import { RiveContainer } from '~/components/Shared/RiveContainer/RiveContainer';

export type RiveThumbnailProps = {
  src: string;
  width: number;
  height: number;
  // A CSS string is allowed because the value only lands in the container's inline style —
  // it is never used for canvas math (unlike width/height, which stay numeric).
  borderRadius?: number | string;
};

export const RiveThumbnail = memo(({ src, width, height, borderRadius = 4 }: RiveThumbnailProps) => {
  return (
    <RiveContainer
      src={src}
      className="overflow-hidden"
      style={{
        width,
        height,
        borderRadius,
      }}
      data-testid="RIVE_THUMBNAIL_CONTAINER"
      errorFallback={
        <div data-testid="RIVE_THUMBNAIL_ERROR" className="flex size-full">
          <FileExtensionPreview ext="riv" color="gray" size="medium" className="flex-1 justify-center" />
        </div>
      }
      resizeDependencies={[width, height]}
    />
  );
});

RiveThumbnail.displayName = 'RiveThumbnail';
